import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from "rxjs";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Store} from "@ngrx/store";
import {AppState} from "../../../core/store/core.state";
import {LocalStorageService} from "../../../core/services";
import {ConfigService, MapService} from "../../services";
import {AppWorkConfig} from "../../models/config.model";

export interface DrawEventData {
  layer: any,
  extraData?: any,
}

@Component({
  selector: 'app-map-form-base',
  template: ''
})
export class ContainerFormMapBaseComponent implements OnInit, OnDestroy {

  protected _item: any;

  workConfig: AppWorkConfig;

  form: FormGroup = null;
  formChange = false;

  subscriptions: Subscription[] = [];

  @Output() readonly = false;
  @Output() closeEvent = new EventEmitter<any>();
  @Output() drawEvent = new EventEmitter<DrawEventData>();

  constructor(
    protected fb: FormBuilder,
    protected store: Store<AppState>,
    protected localStorageService: LocalStorageService,
    protected mapService: MapService) {
  }


  get item(): any {
    return this._item;
  }

  @Input()
  set item(value: any) {
    this._item = {...value};
    this.setItem();
  }

  setItem() { }
  getTitle(): string {
    return '';
  }

  ngOnInit(): void {
    this.workConfig = ConfigService.getAppConfig().workConfig;
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  isFormValid() {
    return this.form && this.form.valid && (this.form.dirty || this.formChange);
  }

  onCancel() {
    this.closeEvent.emit(this.item);
  }

  getValues(): any {
    return { ...this.item };
  }

  onSubmit(params = null) {
    if (this.isFormValid()) {
      const item = this.getValues();
      this.submit(item, params);
      this.formChange = false;
      this.closeEvent.emit(item);
    }
  }

  submit(item: any, params: any = null) { }

  canUpdate(){
    return false;
  }

  formatInPercent(value: number|string){
    return Number(value)*100;
  }

  workConfigEnabled(){
    return this.workConfig && this.workConfig.enable;
  }
}
